<template>
    <v-chip outlined v-if="$vuetify.breakpoint.mdAndUp">
        <v-avatar left>
            <v-img v-if="getImageFromModel(model, supportedCashType).length > 0" :src="getImageFromModel(model, supportedCashType)" aspect-ratio="1" width="48" />
            <v-fa-icon v-else icon="box" small />
        </v-avatar>
        {{ model }}
    </v-chip>
    <span v-else v-text="model" />
</template>

<script>
import { getImageFromModel_48 as getImageFromModel } from "@/utility/Constants.ts";

export default {
    data() {
        return {
            getImageFromModel,
        };
    },
    props: ["model", "supportedCashType"],
};
</script>
